import {
  createLogEngineForBrowser,
  createMutableLogger,
} from "@teladoc/ucs-logging"
import type { BrowserLogOptions, Logger } from "@teladoc/ucs-logging"

export type { Logger }

export const createLogger = (options?: BrowserLogOptions): Logger => {
  const logOptions: BrowserLogOptions = {
    minLevel: "info",
    ...(options ?? {}),
  }
  return createLogEngineForBrowser(logOptions).createLogger()
}

const internalMutableLogger = createMutableLogger(createLogger())

export const logger: Logger = internalMutableLogger.createChildLogger({
  category: "gwa-logger",
})

export const updateBaseLogger = (baseLogger: Logger): void => {
  internalMutableLogger.updateLogger(baseLogger)
}
